/**
 * @desc 锁仓提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryLockWarehouseRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/lockWarehouse`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
